import { AppPaletteEnum } from './palette'
import { AppDataTemplateEnum } from './template'
import AppCommon from './common'

export const AppEnum = {
  ...AppCommon,
  palette: AppPaletteEnum,
  template: AppDataTemplateEnum,
}
